import React, { useEffect } from 'react'
import {
  Card,
  CardHeader,
  Grid,
  Typography,
  Button,
  Checkbox,
  CardContent
} from '@material-ui/core'
import classes from '../../../pages/createOrder/index.module.scss'
import List from '../../../pages/createOrder/components/list'
import VitrinList from '../../../pages/createOrder/components/listVitrin'
import RonadIcons from '../../iconComponent'

const vitrin = localStorage.getItem('vitrin') || null

function ProductList(props: any) {
  const {
    setDialog,
    itemsInfo,
    extraLabelRequired,
    setConfirmDelete,
    isVitrinOrderItem,
    setIsVitrinOrderItem,
    setNumberProductList,
    editMode,
    notFounded
  } = props

  const totalInventoryItem = () => {
    return itemsInfo.reduce((total: any, el: any) => {
      return total + parseInt(el.amount)
    }, 0)
  }

  const totalInventory = totalInventoryItem()

  useEffect(() => {
    setNumberProductList({
      variantCount: itemsInfo.length,
      totalCount: totalInventory
    })
  }, [totalInventory])

  return (
    <Card className={classes.card}>
      <CardContent
        className={classes.cardContentOrder}
        style={{ padding: '0' }}
      >
        <Grid container justifyContent='flex-end'>
          {!editMode && extraLabelRequired && (
            <Button
              variant='outlined'
              className={classes.addProductIcon}
              style={{ marginBottom: '24px', marginLeft: '12px' }}
              color='primary'
              size='large'
              endIcon={
                <RonadIcons
                  name='plusCircleOutline'
                  className='text-primary'
                  size={0.8}
                />
              }
              onClick={props.extractItems}
              id='addProduct'
            >
              {'افزودن کالا با فایل فاکتور'}
            </Button>
          )}
          <Button
            variant='outlined'
            className={classes.addProductIcon}
            style={{ marginBottom: '24px' }}
            color='primary'
            size='large'
            endIcon={
              <RonadIcons
                name='plusCircleOutline'
                className='text-primary'
                size={0.8}
              />
            }
            onClick={() => {
              isVitrinOrderItem
                ? setDialog('openAddVitrinItem')
                : setDialog('openAddItem')
            }}
            id='addProduct'
          >
            {'افزودن کالا به سفارش'}
          </Button>
        </Grid>
        {vitrin && (
          <Grid item xs={12} sm={12} md={12} lg={12} alignItems='flex-start'>
            <div className={classes.item}>
              <span className={classes.label}>
                <Checkbox
                  checked={isVitrinOrderItem}
                  onChange={(e) => {
                    setIsVitrinOrderItem(e.target.checked)
                  }}
                  color='secondary'
                  inputProps={{
                    'aria-label': 'secondary checkbox'
                  }}
                  id='fulfillmentServiceCheckBox'
                />
              </span>

              <div
                style={{
                  width: '100%',
                  marginTop: '20px'
                }}
              >
                <span>این سفارش از کالاهای ویترین فروشندگان دیگر است</span>
              </div>
            </div>
          </Grid>
        )}
        {notFounded.length > 0 && (
          <Grid item md={12} sm={12}>
            <div className='notif-error' style={{ marginTop: '8px' }}>
              <RonadIcons
                name='information'
                className='text-danger'
                size={0.8}
              />
              <Typography style={{ marginRight: '10px', fontSize: '14px' }}>
                کد یکپارچگی کالاهای زیر تعریف نشده است.
              </Typography>
            </div>
          </Grid>
        )}
        {notFounded?.map((el: any) => (
          <p>{el}</p>
        ))}
        {itemsInfo.length > 0 && (
          <p>
            تعداد کالاها: {itemsInfo.length} / تعداد آیتم‌های انبار:{' '}
            {totalInventory}
          </p>
        )}
        {itemsInfo.length > 0 && (
          <Grid style={{ padding: '0', margin: '0' }}>
            {isVitrinOrderItem ? (
              <VitrinList
                data={itemsInfo}
                deleteItem={(body: any) => setConfirmDelete(body)}
              />
            ) : (
              <List
                data={itemsInfo}
                deleteItem={(body: any) => setConfirmDelete(body)}
              />
            )}
          </Grid>
        )}
      </CardContent>
    </Card>
  )
}

export default ProductList
